module.exports = __webpack_public_path__ + "img/party_upper_3.2b16069a.jpg";